<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec">
    <h2>Relatórios contábeis <span style="font-size:14px;">(milhares de R$)</span></h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span :class="{ hideSeta: setaRightState }"><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div> 
      <div class="col36 marginColBottom">
        <span class="titGraf2">Balanço patrimonial em 31 de dezembro</span>
        <table border="0" cellspacing="1" cellpadding="0" bgcolor="#FFFFFF">
            <tr class="tittab backTab1">
              <th>ATIVO</th>
              <th style="text-align:center;">2018</th> 
              <th style="text-align:right;">2017</th>
            </tr>
            <tr class="tittab backTab2">
              <td>Circulante</td>
              <td style="text-align:center;">174.965</td>
              <td style="text-align:right;">189.482</td>
            </tr>
            <tr class="contTab">
              <td>Caixa e<br />
                  Equivalentes de Caixa</td>
              <td style="text-align:center; vertical-align:bottom;">171.523</td>
              <td style="text-align:right; vertical-align:bottom;">187.011</td>
            </tr>
            <tr class="contTab">
              <td>Adiantamento de<br />
                  Direito Autoral</td>
              <td style="text-align:center; vertical-align:bottom;">2.847</td>
              <td style="text-align:right; vertical-align:bottom;">2.033</td>
            </tr>
            <tr class="contTab">
              <td>Adiantamento a<br />
                  Fornecedores</td>
              <td style="text-align:center; vertical-align:bottom;">7</td>
              <td style="text-align:right; vertical-align:bottom;">19</td>
            </tr>
            <tr class="contTab">
              <td>Impostos a<br />
                  Recuperar</td>
              <td style="text-align:center; vertical-align:bottom;">196</td>
              <td style="text-align:right; vertical-align:bottom;">3</td>
            </tr>
            <tr class="contTab">
              <td>Despesas<br />
                  Antecipadas</td>
              <td style="text-align:center; vertical-align:bottom;">278</td>
              <td style="text-align:right; vertical-align:bottom;">275</td>
            </tr>
            <tr class="contTab">
              <td>Outros<br />
                 Créditos</td>
              <td style="text-align:center; vertical-align:bottom;">114</td>
              <td style="text-align:right; vertical-align:bottom;">141</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Não circulante</td>
              <td class="tittab" style="text-align:center;">24.227</td>
              <td class="tittab" style="text-align:right;">25.346</td>
            </tr>
            <tr class="contTab">
              <td>Realizável a<br />
                  Longo Prazo</td>
              <td style="text-align:center; vertical-align:bottom;">56</td>
              <td style="text-align:right; vertical-align:bottom;">23</td>
            </tr>
            <tr class="contTab">
              <td style="padding-top:0px; padding-left:20px;">Depósitos e Caução</td>
              <td style="text-align:center; vertical-align:bottom; padding-top:0px;">56</td>
              <td style="text-align:right; vertical-align:bottom; padding-top:0px;">23</td>
            </tr>
            <tr class="contTab">
              <td>Imobilizado</td>
              <td style="text-align:center; vertical-align:bottom;">23.626</td>
              <td style="text-align:right; vertical-align:bottom;">24.806</td>
            </tr>
            <tr class="contTab">
              <td>Intangível</td>
              <td style="text-align:center; vertical-align:bottom;">545</td>
              <td style="text-align:right; vertical-align:bottom;">517</td>
            </tr>
            <tr class="tittab backTab2">
              <td>Total do ativo</td>
              <td style="text-align:center;">199.192</td>
              <td style="text-align:right;">214.828</td>
            </tr>
        </table>
        <!-- <div style="width:90%; padding:10px 0 0 0;">
          <img style="width:100%;" src="../assets/rc_tabela1.jpg" />
        </div> -->
      </div><!-- col74ponto5 -->
      <div class="col36">
        <span class="titGraf2">Balanço patrimonial em 31 de dezembro</span>
        <table border="0" cellspacing="1" cellpadding="0" bgcolor="#FFFFFF">
            <tr class="tittab backTab1">
              <th>PASSIVO</th>
              <th style="text-align:center;">2018</th> 
              <th style="text-align:right;">2017</th>
            </tr>
            <tr class="tittab backTab2">
              <td>Circulante</td>
              <td style="text-align:center;">131.709</td>
              <td style="text-align:right;">151.146</td>
            </tr>
            <tr class="contTab">
              <td>Obrigações Fiscais/<br />
                  Sociais a Recolher</td>
              <td style="text-align:center; vertical-align:bottom;">1.732</td>
              <td style="text-align:right; vertical-align:bottom;">4.777</td>
            </tr>
            <tr class="contTab">
              <td>Contas<br />
                  a Pagar</td>
              <td style="text-align:center; vertical-align:bottom;">142</td>
              <td style="text-align:right; vertical-align:bottom;">133</td>
            </tr>
            <tr class="contTab">
              <td>Provisões de<br />
                  Férias/Outras</td>
              <td style="text-align:center; vertical-align:bottom;">2.581</td>
              <td style="text-align:right; vertical-align:bottom;">1.836</td>
            </tr>
            <tr class="contTab">
              <td>Direitos Autorais<br />
                  a Pagar</td>
              <td style="text-align:center; vertical-align:bottom;">4.321</td>
              <td style="text-align:right; vertical-align:bottom;">20.692</td>
            </tr>
            <tr class="contTab">
              <td>Direitos Arrecadados<br />
                  a Distribuir</td>
              <td style="text-align:center; vertical-align:bottom; border-bottom: solid 1px #008ed3;">122.933</td>
              <td style="text-align:right; vertical-align:bottom; border-bottom: solid 1px #008ed3;">123.708</td>
            </tr>
            <tr class="contTab">
              <td style="padding-top:0; padding-bottom:0; padding-left:20px;">Nacional</td>
              <td style="text-align:center; vertical-align:bottom; padding-top:0; padding-bottom:0;">33.222</td>
              <td style="text-align:right; vertical-align:bottom; padding-top:0; padding-bottom:0;">34.322</td>
            </tr>
            <tr class="contTab">
              <td style="padding-top:0; padding-left:20px;">Exterior</td>
              <td style="text-align:center; vertical-align:bottom; padding-top:0;">89.711</td>
              <td style="text-align:right; vertical-align:bottom; padding-top:0;">89.386</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Não circulante</td>
              <td class="tittab" style="text-align:center;">14.141</td>
              <td class="tittab" style="text-align:right;">14.191</td>
            </tr>
            <tr class="contTab">
              <td>Provisão de <br />
                  Honorários Advocatícios</td>
              <td style="text-align:center; vertical-align:bottom;">921</td>
              <td style="text-align:right; vertical-align:bottom;">971</td>
            </tr>
            <tr class="contTab">
              <td>Provisão<br />
                  Contencioso
              </td>
              <td style="text-align:center; vertical-align:bottom; padding-top:0px;">-</td>
              <td style="text-align:right; vertical-align:bottom; padding-top:0px;">-</td>
            </tr>
            <tr class="contTab">
              <td>Provisão Auto de <br />
                  Infração - CIDE</td>
              <td style="text-align:center; vertical-align:bottom;">13.220</td>
              <td style="text-align:right; vertical-align:bottom;">13.220</td>
            </tr>
            <tr class="tittab backTab2">
              <td>Patrimônio líquido</td>
              <td style="text-align:center;">53.342</td>
              <td style="text-align:right;">49.491</td>
            </tr>
            <tr class="contTab">
              <td>Provisão Auto de <br />
                  Infração - CIDE</td>
              <td style="text-align:center; vertical-align:bottom;">53.342</td>
              <td style="text-align:right; vertical-align:bottom;">49.491</td>
            </tr>
            <tr class="tittab backTab2">
              <td>Total do passivo</td>
              <td style="text-align:center;">199.192</td>
              <td style="text-align:right;">214.828</td>
            </tr>
        </table>
        <!-- <div style="width:90%; padding:10px 0 0 0;">
          <img style="width:100%;" src="../assets/rc_tabela2.jpg" />
        </div> -->
      </div><!-- col74ponto5 -->
    </section>
    <section class="sectionRow" style="margin:40px 0 0 0;">
      <div class="col23ponto5"></div><!-- col23ponto5 -->
      <div class="col36 marginColBottom">
        <span class="titGraf2">Demonstração do superávit do exercício</span>
        <table class="table2" border="0" cellspacing="1" cellpadding="0" bgcolor="#FFFFFF">
            <tr class="tittab backTab1">
              <th></th>
              <th style="text-align:center;">01/jan/18<br />31/dez/18</th> 
              <th style="text-align:right;">01/jan/17<br />31/dez/17</th> 
            </tr>
            <tr class="tittab backTab2">
              <td>Receitas operacionais</td>
              <td style="text-align:center;">30.838</td>
              <td style="text-align:right;">34.703</td>
            </tr>
            <tr class="contTab">
              <td style="padding-bottom:0;">Taxa de Administração</td>
              <td style="text-align:center; vertical-align:bottom; padding-bottom:0; border-bottom:1px solid #008ed3;">30.036</td>
              <td style="text-align:right; vertical-align:bottom; padding-bottom:0; border-bottom:1px solid #008ed3;">34.610</td>
            </tr>
            <tr class="contTab">
              <td style="padding:0 0 0 20px;">Exterior</td>
              <td style="text-align:center; vertical-align:bottom; padding-top:0; padding-bottom:0;">627</td>
              <td style="text-align:right; vertical-align:bottom; padding-top:0; padding-bottom:0;">493</td>
            </tr>
            <tr class="contTab">
              <td style="padding:0 0 0 20px;">Nacional</td>
              <td style="text-align:center; vertical-align:bottom; padding-top:0;">29.409</td>
              <td style="text-align:right; vertical-align:bottom; padding-top:0;">34.117</td>
            </tr>
            <tr class="contTab">
              <td>Outras Receitas</td>
              <td style="text-align:center; vertical-align:bottom;">802</td>
              <td style="text-align:right; vertical-align:bottom;">93</td>
            </tr>
            <tr class="tittab backTab2">
              <td>Despesas operacionais</td>
              <td style="text-align:center;">(33.276)</td>
              <td style="text-align:right;">(34.505)</td>
            </tr>
            <tr class="contTab">
              <td>Pessoal</td>
              <td style="text-align:center; vertical-align:bottom;">(19.208)</td>
              <td style="text-align:right; vertical-align:bottom;">(18.255)</td>
            </tr>
            <tr class="contTab">
              <td>Administrativas</td>
              <td style="text-align:center; vertical-align:bottom;">(9.320)</td>
              <td style="text-align:right; vertical-align:bottom;">(11.475)</td>
            </tr>
            <tr class="contTab">
              <td>Remuneração Mínima<br />
                  e Assistência Social</td>
              <td style="text-align:center; vertical-align:bottom;">(440)</td>
              <td style="text-align:right; vertical-align:bottom;">(428)</td>
            </tr>
            <tr class="contTab">
              <td>Depreciação</td>
              <td style="text-align:center; vertical-align:bottom;">(1.524)</td>
              <td style="text-align:right; vertical-align:bottom;">(1.146)</td>
            </tr>
            <tr class="contTab">
              <td>Tributárias</td>
              <td style="text-align:center; vertical-align:bottom;">(2.784)</td>
              <td style="text-align:right; vertical-align:bottom;">(3.201)</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Superávit/déficit operacional antes do resultado financeiro</td>
              <td class="tittab" style="text-align:center;">(2.438)</td>
              <td class="tittab" style="text-align:right;">198</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Resultado financeiro</td>
              <td class="tittab" style="text-align:center;">9.569</td>
              <td class="tittab" style="text-align:right;">10.778</td>
            </tr>
            <tr class="contTab">
              <td>Receita Financeira</td>
              <td style="text-align:center; vertical-align:bottom;">9.801</td>
              <td style="text-align:right; vertical-align:bottom;">10.932</td>
            </tr>
            <tr class="contTab">
              <td>Despesa Financeira</td>
              <td style="text-align:center; vertical-align:bottom;">(232)</td>
              <td style="text-align:right; vertical-align:bottom;">(154)</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Superávit antes da contribuição social e imposto de renda</td>
              <td class="tittab" style="text-align:center;">7.131</td>
              <td class="tittab" style="text-align:right;">10.976</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Contribuição social e imposto de renda</td>
              <td class="tittab" style="text-align:center;">(3.280)</td>
              <td class="tittab" style="text-align:right;">(4.743)</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Superávit do exercício</td>
              <td class="tittab" style="text-align:center;">3.851</td>
              <td class="tittab" style="text-align:right;">6.233</td>
            </tr>
        </table>
      </div>
      <div class="col36">
        <span class="titGraf2">Demonstração de superávits acumulados</span>
        <table class="table2" border="0" cellspacing="1" cellpadding="0" bgcolor="#FFFFFF">
            <tr class="tittab backTab1">
              <th></th>
              <th style="text-align:center;">01/jan/18<br />31/dez/18</th> 
              <th style="text-align:right;">01/jan/17<br />31/dez/17</th> 
            </tr>
            <tr class="tittab backTab2">
              <td>Saldo do início do exercício</td>
              <td style="text-align:center;">49.491</td>
              <td style="text-align:right;">43.258</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Superávit/déficit do exercício</td>
              <td class="tittab" style="text-align:center;">3.851</td>
              <td class="tittab" style="text-align:right;">6.233</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Saldo no fim do exercício</td>
              <td class="tittab" style="text-align:center;">53.342</td>
              <td class="tittab" style="text-align:right;">49.491</td>
            </tr>
        </table>
      </div>
    </section>
    <section class="sectionRow" style="padding:40px 0 0 0;">
      <div class="col23ponto5"></div><!-- col23ponto5 -->
      <div class="col48ponto9">
        <span class="titGraf2">Demonstração dos fluxos de caixa</span>
        <table class="table2" border="0" cellspacing="1" cellpadding="0" bgcolor="#FFFFFF">
            <tr class="tittab backTab1">
              <th style="vertical-align:middle;">Fluxo de caixa das atividades operacionais</th>
              <th style="text-align:center;">01/jan/18<br />31/dez/18</th> 
              <th style="text-align:right;">01/jan/17<br />31/dez/17</th> 
            </tr>
            <tr class="tittab backTab2">
              <td>Superávit/Déficit do exercício</td>
              <td style="text-align:center;">3.851</td>
              <td style="text-align:right;">6.233</td>
            </tr>
            
            <tr class="contTab">
              <td>Ajustes por:</td>
              <td style="text-align:center; vertical-align:bottom;"></td>
              <td style="text-align:right; vertical-align:bottom;"></td>
            </tr>
            <tr class="contTab">
              <td>Depreciação e amortização</td>
              <td style="text-align:center; vertical-align:bottom;">1.524</td>
              <td style="text-align:right; vertical-align:bottom;">1.146</td>
            </tr>
            <tr class="contTab">
              <td>Baixa de Bens do Ativo Imobilizado</td>
              <td style="text-align:center; vertical-align:bottom;">26</td>
              <td style="text-align:right; vertical-align:bottom;">82</td>
            </tr>
            <tr class="contTab">
              <td>Constituições de provisões</td>
              <td style="text-align:center; vertical-align:bottom;">695</td>
              <td style="text-align:right; vertical-align:bottom;">717</td>
            </tr>
            <tr class="contTab">
              <td>Aumento nas Contas de Adiantamentos</td>
              <td style="text-align:center; vertical-align:bottom;">(802)</td>
              <td style="text-align:right; vertical-align:bottom;">(468)</td>
            </tr>
            <tr class="contTab">
              <td>Aumento (Redução) em Impostos a Recuperar</td>
              <td style="text-align:center; vertical-align:bottom;">(193)</td>
              <td style="text-align:right; vertical-align:bottom;">1.747</td>
            </tr>
            <tr class="contTab">
              <td>Aumento nos Outros Ativos</td>
              <td style="text-align:center; vertical-align:bottom;">(9)</td>
              <td style="text-align:right; vertical-align:bottom;">(43)</td>
            </tr>
            <tr class="contTab">
              <td>(Aumento) Redução em Contas a Pagar</td>
              <td style="text-align:center; vertical-align:bottom;">9</td>
              <td style="text-align:right; vertical-align:bottom;">(162)</td>
            </tr>
            <tr class="contTab">
              <td>Reduçao (Aumento) de Obrigações Fiscais /Sociais</td>
              <td style="text-align:center; vertical-align:bottom;">(3.045)</td>
              <td style="text-align:right; vertical-align:bottom;">3.751</td>
            </tr>
            <tr class="contTab">
              <td>Redução (Aumento) de Direitos Autorais a Pagar</td>
              <td style="text-align:center; vertical-align:bottom;">(16.371)</td>
              <td style="text-align:right; vertical-align:bottom;">19.900</td>
            </tr>
            <tr class="contTab">
              <td>Redução (Aumento) de Direitos Arrecadados a Distribuir</td>
              <td style="text-align:center; vertical-align:bottom;">(775)</td>
              <td style="text-align:right; vertical-align:bottom;">57.113</td>
            </tr>
            <tr class="contTab">
              <td>Caixa Líquido Proveniente das (Aplicado nas) Atividades Operacionais</td>
              <td style="text-align:center; vertical-align:bottom;">(15.090)</td>
              <td style="text-align:right; vertical-align:bottom;">90.016</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Fluxo de caixa das atividades e investimentos</td>
              <td class="tittab" style="text-align:center;"></td>
              <td class="tittab" style="text-align:right;"></td>
            </tr>
            <tr class="contTab">
              <td>Aquisições de Imobilizado</td>
              <td style="text-align:center; vertical-align:bottom;">(338)</td>
              <td style="text-align:right; vertical-align:bottom;">(6.640)</td>
            </tr>
            <tr class="contTab">
              <td>Aplicação no Intangível</td>
              <td style="text-align:center; vertical-align:bottom;">(60)</td>
              <td style="text-align:right; vertical-align:bottom;">(78)</td>
            </tr>
            <tr class="contTab">
              <td>Caixa Líquido Aplicado nas Atividades de Investimentos</td>
              <td style="text-align:center; vertical-align:bottom;">(398)</td>
              <td style="text-align:right; vertical-align:bottom;">(6.718)</td>
            </tr>
            <tr class="backTab2">
              <td class="tittab">Aumento do caixa e equivalentes de caixa</td>
              <td class="tittab" style="text-align:center;">(15.488)</td>
              <td class="tittab" style="text-align:right;">83.298</td>
            </tr>
            <tr class="contTab">
              <td>Caixa e Equivalentes de Caixa no Início do Exercício</td>
              <td style="text-align:center; vertical-align:bottom;">187.011</td>
              <td style="text-align:right; vertical-align:bottom;">103.713</td>
            </tr>
            <tr class="contTab">
              <td>Caixa e Equivalentes de Caixa no Final do Exercício</td>
              <td style="text-align:center; vertical-align:bottom;">171.523</td>
              <td style="text-align:right; vertical-align:bottom;">187.011</td>
            </tr> 
            <tr class="backTab2">
              <td class="tittab">Variação do caixa e equivalentes de caixa</td>
              <td class="tittab" style="text-align:center;">(15.488)</td>
              <td class="tittab" style="text-align:right;">83.298</td>
            </tr>
        </table>
      </div>
      <div class="col23ponto5">
      </div>
    </section>
    <section class="sectionRow" style="padding:40px 0 0 0;">
      <div class="col23ponto5"></div><!-- col23ponto5 -->
      <div class="col74ponto5">
        <div class="end">
          <div class="linhaEnd"></div>
          <div class="imgEnd"><img src="../assets/logo_end.png" /></div>
        </div>
      </div>
    </section>
  </div>    
</div>
</template>

<script>
export default {
  name: 'RelatoriosContabeis',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
      setaRightState: false
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  created(){
    this.hideSetaFunc();
  },
  methods:{
    hideSetaFunc: function(){
      let route = this.$route.path;
      if (route === "/relatorios-contabeis") {
          this.setaRightState = true
        } else { 
          this.setaRightState = false
        }    
    },
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 50 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh); 
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table{
  width:100%; 
  margin:10px 0 0 0;
}
th, td{
  padding:6px 10px 6px 10px;
}
.backTab1{
  background-color:#008ed3; 
  text-align:left; 
  vertical-align:center;
}
.backTab2{
  background-color:#006090;
}

.tittab{
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color:#FFFFFF;
  vertical-align: middle;
}
.table2 .tittab{
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  color:#FFFFFF;
  vertical-align: middle;
}

.table2 .contTab{
  font-family: Arial, Helvetica, sans-serif;
  font-size: 11px;
  color:#008ed3;
  vertical-align: middle;
  padding:4px 10px 4px 10px !important;
}

.contTab{
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  color:#008ed3;
  vertical-align: middle;
  padding:4px 10px 4px 10px !important;
}
.end{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.end .linhaEnd{
  width:90%;
  height: 1px;
  background-color: #BFBFBF;
  margin:40px 0 40px 0;
}

.end .imgEnd{
  padding:20px 0 20px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/RelatoriosContabeis.vue